<template>
  <div class="block">
    <el-carousel indicator-position="outside" height="860px">
      <el-carousel-item v-for="item in itemData.imgList" :key="item.id" @change="changeItem(item)">
        <img :src="item.src" alt="" class="image">
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<style scoped>
.block{
  width: 1920px;
}
.image {
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  /*锁定图片的长宽比 */
}
</style>
<script>
export default {
  name: 'img',
  data() {
    return {
      dataAll:Data,
      itemData:{}
    }
  },
  mounted() {
    let that = this;
    console.log(that.itemData);

    for(let index in that.dataAll){
      let itemData= that.dataAll[index];
      console.log(itemData.type);
      if(that.$parent.$parent.message = itemData.type){
        that.itemData = itemData;
        console.log(that.itemData);
        break;
      }
    }
  },
  methods: {
    //切换轮播图
    changeItem() {

    }
  }


}
</script>



// WEBPACK FOOTER //
// src/components/image/image.vue